module.exports = __webpack_public_path__ + "media/images/pic/saska/saska_news-77fb173e0ca08b9d40c70e4bea05fdaf.webp";